import { Link, useOutletContext } from "react-router-dom";
import { Download, Crown, UserPlus } from "lucide-react";
import Hero from "@/components/site/Hero";
import NewsSection from "@/components/site/NewsSection";

const CARDS = [
  ["/pobierz", Download, "Pobierz grę", "Klient i launcher. Patcher sam dociągnie najnowsze pliki."],
  ["/ranking", Crown, "Ranking", "Najlepsi gracze i gildie serwera."],
  ["/rejestracja", UserPlus, "Załóż konto", "Jedno konto, trzy imperia. Rejestracja trwa minutę."],
];

export default function Website() {
  const { settings } = useOutletContext();
  return (
    <>
      <Hero settings={settings} />
      <section className="px-6 md:px-10 max-w-7xl mx-auto -mt-6 md:-mt-10 relative z-10" data-testid="home-cards">
        <div className="grid md:grid-cols-3 gap-5">
          {CARDS.map(([to, Icon, title, text]) => (
            <Link key={to} to={to} className="steel-panel steel-hover chamfer block" data-testid={`home-card-${to.slice(1)}`}>
              <div className="steel-inner chamfer p-7">
                <Icon className="text-amber-400 mb-5" size={26} />
                <h3 className="font-display text-xl text-slate-100 tracking-wide">{title}</h3>
                <p className="text-sm text-slate-400 mt-2">{text}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
      <NewsSection limit={3} showAll />
    </>
  );
}
